import { IFilterComp, IFilterParams, IDoesFilterPassParams } from "ag-grid-community";

interface IsRefundableFilterParams extends IFilterParams {
  labelAll?: string;
  labelRefundable?: string;
  labelNotRefundable?: string;
}

export class IsRefundableFilter implements IFilterComp {
  private params!: IsRefundableFilterParams;
  private container!: HTMLElement;
  private selectedValue: "all" | "true" | "false" = "all";
  private hidePopup?: () => void;

  init(params: IsRefundableFilterParams): void {
    this.params = params;

    this.container = document.createElement("div");
    this.container.className = "bg-white border border-gray-300 rounded p-2 min-w-[240px]";

    const group = document.createElement("div");
    group.className = "flex flex-col gap-2";

    group.append(
      this.buildRadioRow("all", params.labelAll || "All"),
      this.buildRadioRow("true", params.labelRefundable || "Refundable"),
      this.buildRadioRow("false", params.labelNotRefundable || "Not refundable"),
    );

    this.container.appendChild(group);

    this.hidePopup = () => {
      requestAnimationFrame(() => {
        const filterMenu = this.container.closest(".ag-menu.ag-filter-menu");
        filterMenu?.remove();
      });
    };

    this.setModel(null);
  }

  getGui(): HTMLElement {
    return this.container;
  }

  afterGuiAttached(): void {
    this.setModel(null);
  }

  isFilterActive(): boolean {
    return this.selectedValue !== "all";
  }

  getModel(): any | null {
    return null;
  }

  setModel(_model: any | null): void {
    const fullModel: any = this.params.api?.getFilterModel?.() || {};
    const refundable = fullModel.is_refundable?.filter;
    this.selectedValue = refundable === "true" ? "true" : refundable === "false" ? "false" : "all";
    this.syncRadios();
  }

  doesFilterPass(_params: IDoesFilterPassParams): boolean {
    return true;
  }

  private buildRadioRow(value: "all" | "true" | "false", label: string): HTMLElement {
    const row = document.createElement("label");
    row.className = "flex items-center gap-2 py-1 text-sm cursor-pointer select-none";

    const input = document.createElement("input");
    input.type = "radio";
    input.name = "is_refundable_filter";
    input.value = value;
    input.checked = this.selectedValue === value;
    input.addEventListener("change", () => {
      if (!input.checked) return;
      this.selectedValue = value;

      const fullModel: any = this.params.api?.getFilterModel?.() || {};
      delete fullModel.is_refundable;

      if (value === "true" || value === "false") {
        fullModel.is_refundable = { filterType: "text", type: "equals", filter: value };
      }

      this.params.api?.setFilterModel?.(fullModel);
      this.params.api?.onFilterChanged?.();
      window.setTimeout(() => this.setModel(null), 0);
      this.hidePopup?.();
    });

    const text = document.createElement("span");
    text.textContent = label;

    row.append(input, text);
    return row;
  }

  private syncRadios(): void {
    const radios = this.container.querySelectorAll<HTMLInputElement>(
      'input[type="radio"][name="is_refundable_filter"]',
    );
    radios.forEach((radio) => (radio.checked = radio.value === this.selectedValue));
  }
}
